import { twMerge } from 'tailwind-merge';
import { Input } from './BaseInput';
import { ErrorList, type ListOfErrors } from './ErrorList';
import { Label } from './Label';

export default function TextField({
  label,
  name,
  type = 'text',
  placeholder,
  className,
  inputProps,
  errors,
}: {
  label?: React.ReactNode;
  name: string;
  type?: string;
  placeholder?: string;
  className?: string;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  errors?: ListOfErrors;
}) {
  return (
    <TextFieldWrapper className={className}>
      <Label className="text-inherit" htmlFor={name}>
        {label}
      </Label>
      <Input
        type={type}
        id={name}
        name={name}
        placeholder={placeholder}
        {...inputProps}
      />
      <ErrorList id={name} errors={errors} />
    </TextFieldWrapper>
  );
}

export function TextFieldWrapper({
  children,
  className,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div
      className={twMerge(
        'grid w-full  items-center gap-1.5',
        'text-secondary has-[input:focus-visible]:text-primary has-[aria-invalid=true]:text-negative',
        className
      )}
    >
      {children}
    </div>
  );
}
